import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from 'src/app/services/home/snackbar.service';

@Component({
  selector: 'app-common-confirm-dialog',
  templateUrl: './common-confirm-dialog.component.html',
  styleUrls: ['./common-confirm-dialog.component.css']
})
export class CommonConfirmDialogComponent implements OnInit {

  ShowSpinner : boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CommonConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackBar: SnackbarService
  ) { }

  ngOnInit(): void {
  }
  onSubmit(){
    this.ShowSpinner = true;
    this.dialogRef.close({isConfirmed: true });
    this.ShowSpinner = false;

  }
  closeDialog() {
    this.dialogRef.close();
  }
}
